import loadable from '@loadable/component';

export const ActivityEditPage = loadable(() =>
    import(/* webpackChunkName: "ActivityEditPage" */ './admin/activityedit')
);

export const ActivityPriceItemEditPage = loadable(() =>
    import(/* webpackChunkName: "ActivityPriceItemEditPage" */ './admin/activitypriceitemeditpage')
);
